const consolidatedDebtAnalysisResource = (() => {
	const _default_config = {
		total_sources: 0,
		width: {
			chart1: 0
		},
		color_codes: ["#158cdc", "#fe9006", "#079e89", "#aa55e8", "#cc2481", "#24da0e", "#dccc0e", "#5794e0", "#4d3a67", "#524c5a", "#8a9eab"]
	};
	const init = (default_config, resource, resource_config) => {
		Object.assign(_default_config, default_config);
		Object.assign(_default_config, resource_config);
		if(!_default_config.data[0]["report"] || _default_config.data[0]["report"].length <= 0){
			$(".form-inline").hide();
			$("#graphicalView").hide()
			$("#tableview").html("<h6 style='padding:4px 15px;'>Debt Analysis Report NOT Available</h6>")
			analyserV2.addAlertBox("Debt report not available!");
			var fade=document.querySelector(".alert-message-151290"),opacity=1;
			var intervalID=setInterval(function(){opacity>0?(opacity-=.01,fade.style.opacity=opacity):(clearInterval(intervalID),fade.remove())},50);
			analyserV2.resolvePromise();
			return
		}

		_default_config["category_wise_data"] = {};
		let category_wise_data_array = _default_config.data[0]["report"].map(e => { var tuple = {}; tuple[e["category"]] = e["data"]; return tuple; });
		Object.assign(_default_config["category_wise_data"], ...category_wise_data_array);
		_default_config["debtCategory"] = Object.keys(_default_config["category_wise_data"])
		_default_config.active_data_category = _default_config["debtCategory"][0] 
		
		_default_config.resource = resource;
		_default_config.last_selected_account_number_option = _default_config._default_option;
		_default_config.last_selected_month_option = _default_config._default_option;
		_default_config.maped_data = new Map();
		// _default_config.maped_data[_default_config._default_option] = updateData(_default_config.data[0]["report"][0]["data"]);
		_default_config.maped_data[_default_config._default_option] = updateData(_default_config["category_wise_data"][_default_config.active_data_category]);

		_default_config.headers = Object.keys(_default_config.maped_data[_default_config._default_option][0]);
		for (let i = 0; i < _default_config.headers.length; ++i) {
			if (!_default_config.body.config.consolidated_debt_analysis.columns[_default_config.headers[i]]) {
				_default_config.body.config.consolidated_debt_analysis.columns[_default_config.headers[i]] = _default_config["_" + resource]._default_option_config
			}
		}
		for (let i = 0; i < _default_config.account_level.length; ++i){
			if(_default_config.account_level[i]["report"] && _default_config.account_level[i]["report"].length > 0){
				let accountLevelDebtWiseData = _default_config.account_level[i]["report"].find(e => e.category === _default_config.active_data_category)
				// _default_config.maped_data[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = updateData(_default_config.account_level[i]["report"][0]["data"]);
				_default_config.maped_data[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = (accountLevelDebtWiseData && accountLevelDebtWiseData["data"])?updateData(accountLevelDebtWiseData["data"]):[];
			}
		}
		appendHTML();
		templateEvents.updatedOnWindowResize([updatePieChart, updateBarChart]);
	};

	function updateData(data_arr) {
		const resp = [];
		let data = data_arr.summary, obj1, obj2, obj3;
		for (let i = 0; i < data.length; ++i) {
			obj1 = {
				average: (undefined !== data[i]["total_avg_count"])?data[i]["total_avg_count"]:"N/A",
				total: data[i]["total_count"],
				measure: "Count",
				source: data[i].source
			};
			obj2 = {
				average: (undefined !== data[i]["total_avg_amount"])?data[i]["total_avg_amount"]:"N/A",
				total: data[i]["total_amount"],
				measure: "Amount",
				source: ""
			};
			for (let j = 0; j < data[i]["monthly_report"].length; ++j) {
				obj1[data[i]["monthly_report"][j].month] = data[i]["monthly_report"][j].count;
				obj2[data[i]["monthly_report"][j].month] = data[i]["monthly_report"][j].amount;
			}
			resp.push(obj1);
			resp.push(obj2);
		}

		data = data_arr["aggregated_month_report"];
		obj1 = {
			average: (undefined !== data_arr["average_count"])?data_arr["average_count"]:"N/A",
			total: data_arr["total_debt_count"],
			measure: "<b>Count</b>",
			source: "<b>Total</b>"
		};
		obj2 = {
			average: (undefined !== data_arr["average_debt"])?data_arr["average_debt"]:"N/A",
			// total: initScript.separateNumberByDelimiterWithSignAndThousand(data_arr["total_debt"]),
			total: initScript.separateNumberByCommaAndRoundOffwithSign(data_arr["total_debt"]),
			measure: "<b>Amount</b>",
			source: ""
		};
		obj3 = {
			average: (undefined !== data_arr["percentage_of_average_revenue"])?data_arr["percentage_of_average_revenue"]+" %":"N/A",
			total: data_arr["percentage_of_total_revenue"] + "%",
			measure: "",
			source: "<b>Percentage of Calculated Annual Revenue</b>"
		};
		for (let i = 0; i < data.length; ++i) {
			obj1[data[i].month] = "<b>" + data[i].count + "</b>";
			// obj2[data[i].month] = "<b>" + initScript.separateNumberByDelimiterWithSignAndThousand(data[i].amount) + "</b>";
			
			obj2[data[i].month] = "<b>" + initScript.separateNumberByCommaAndRoundOffwithSign(data[i].amount) + "</b>";
			obj3[data[i].month] = "<b>" + data[i]["percentage_of_calculated_revenue"] + "%" + "</b>";
		}
		resp.push(obj1);
		resp.push(obj2);
		resp.push(obj3);
		return resp;
	}

    /**
     * appendHTML : appending html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	const appendHTML = () => {
		_default_config.total_sources = (_default_config.maped_data[_default_config.last_selected_account_number_option].length - 3) / 2;
		appendTableHeaders();
		populateConsolidatedData();
	};

    /**
     * appendTableHeaders : appending html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	const appendTableHeaders = () => {
		let headers = _default_config.headers || Object.keys(_default_config.data[0].summary[0]), mid_panel_headers = initScript.removeUnexpectedElements(headers, ["source", "measure", "total", "average"]);
		_default_config.month = mid_panel_headers;
		_default_config.table_divs = [
			{
				target: {
					"header": "dataLeftFixedConsolidatedDebtAnalysis",
					"row": "dataLeftFixedConsolidatedDebtAnalysis"
				},
				columns: ["source"]
			},
			{
				target: {
					"header": "dataLeft1FixedConsolidatedDebtAnalysis",
					"row": "dataLeft1FixedConsolidatedDebtAnalysis"
				},
				columns: ["measure"]
			},
			{
				target: {
					"header": "midPanelDataHeadConsolidatedDebtAnalysis",
					"row": "midPanelConsolidatedDebtAnalysis"
				},
				"row_parent": { "class": "data-row" },
				columns: mid_panel_headers,
			},
			{
				target: {
					"header": "dataRightFixedConsolidatedDebtAnalysis",
					"row": "dataRightFixedConsolidatedDebtAnalysis"
				},
				columns: ["total"]
			},
			{
				target: {
					"header": "dataRight1FixedConsolidatedDebtAnalysis",
					"row": "dataRight1FixedConsolidatedDebtAnalysis"
				},
				columns: ["average"]
			}
		];
	};

    /**
     * filterData : filtering data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	const filterData = () => {
		let filter_options = _default_config.filter || {};
		filter_options = Object.keys(filter_options);
		for (let i = 0; i < filter_options.length; ++i) {
			const html_config = [];
			let options = _default_config[filter_options[i]];
			if (options.length > 1 && "debtCategory" !== filter_options[i]) options = ["All"].concat(options);
			for (let j = 0; j < options.length; ++j) {
				html_config.push({
					"html": (options[j] === _default_config._default_option) ? (initScript.getObjectValue(_default_config, "body.config." + _default_config.resource + ".filter." + filter_options[i] + ".default_option")) : options[j],
					"config": { "value": options[j] }
				});
			}
			initScript.getHTMLElementByDelimiter(initScript.keyToCamelCaseString(filter_options[i] + "_" + _default_config.resource + "_filter")).html(initScript.getCommonHTML(html_config, "option"));
		}
	};

    /**
     * populateConsolidatedData : showing consolidated html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function populateConsolidatedData() {
		_default_config.sources = [];
		_default_config["consolidated"] = _default_config.data;
		_default_config.account_number = templateEvents.maskingUtility(_default_config.data[0].account_number);
		_default_config.data = _default_config.maped_data[_default_config._default_option];
		templateUtil.appendTabelHeaders(_default_config);
		templateUtil.appendTabelRows(_default_config);
		filterData();
		analyserV2.resolvePromise();
		_default_config.width.chart1 = initScript.getHTMLElementByDelimiter(_default_config.body.class + " #countOfPaymentsPieChart").width();
		updateBarChart();
		for (let i = 0; i < _default_config.maped_data[_default_config._default_option].length - 3; i += 2) _default_config.sources.push(_default_config.maped_data[_default_config._default_option][i].source);
		updateLegends();
	}

    /**
     * updatePieChart : updating pie charts
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function updatePieChart() {
		if (_default_config.last_selected_month_option === _default_config._default_option) return;
		const data = _default_config.maped_data[_default_config.last_selected_account_number_option];
		if (!data || data.length < 4) {
			templateUtil.addEmptySection("countOfPaymentsPieChart");
			templateUtil.addEmptySection("debtRepaidPieChart");
			return;
		}
		const data1 = [], data2 = [], legends = []; 
		for (let i = 0; i < data.length - 3; i += 2) {
			legends.push(data[i]["source"])
			if (data[i][_default_config.last_selected_month_option]) data1.push(data[i][_default_config.last_selected_month_option]) 
			else data1.push(0);
			if (data[i + 1][_default_config.last_selected_month_option]) data2.push(initScript.formatedNumberToValidNumber(data[i + 1][_default_config.last_selected_month_option]));
			else data2.push(0);
		}

		const chart_config = {
			"id": "#countOfPaymentsPieChart",
			"width": _default_config.width.chart1,
			"height": 400,
			"color": _default_config.color_codes,
			"is_doller_format": false,
			data: data1
		};

		if (data1.length) charts.pie.init(chart_config);
		else templateUtil.addEmptySection("countOfPaymentsPieChart");
		chart_config.id = "#debtRepaidPieChart";
		chart_config.data = data2;
		chart_config.is_doller_format = true;
		if (data1.length) charts.pie.init(chart_config);
		else templateUtil.addEmptySection("debtRepaidPieChart");

		updateLegends(legends)
	}
    /**
     * updateBarChart : updating bar charts
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function updateBarChart() {
		const data = _default_config.maped_data[_default_config.last_selected_account_number_option];
		if (!data || data.length < 4) {
			templateUtil.addEmptySection("countOfPaymentsPieChart");
			templateUtil.addEmptySection("debtRepaidPieChart");
			return;
		}
		const config = getBarGraphData(data);
		loadChart(config.data1, "countOfPaymentsPieChart", config.max1, false);
		loadChart(config.data2, "debtRepaidPieChart", config.max2, true);
	}

    /**
     * getBarGraphData : returning graph data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
	const getBarGraphData = (data) => {
		let max1 = 0, max2 = 0, data1 = [], data2 = [], legends = [];
		for (let i = Math.max(0, _default_config.month.length - 12); i < _default_config.month.length; ++i) {
			const obj1 = { "model_name": _default_config.month[i] }, obj2 = { "model_name": _default_config.month[i] };
			let field_count = 1;
			for (let j = 0; j < data.length - 3; j += 2) {
				const amount = initScript.formatedNumberToValidNumber(data[j + 1][_default_config.month[i]]);
				max1 = Math.max(max1, data[j][_default_config.month[i]]);
				max2 = Math.max(max2, amount);
				obj1["field" + field_count] = data[j][_default_config.month[i]];
				obj2["field" + field_count++] = amount;
				if(-1 === legends.indexOf(data[j].source)) legends.push(data[j].source)
			}
			data1.push(obj1);
			data2.push(obj2);
		}
		updateLegends(legends)
		return { data1, max1, data2, max2 }
	};


	/**
	   * loadChart : appending html
	   *
	   * @author Nitesh <nitesh.meena@biz2credit.com>
	   *
	   */

	const loadChart = (data, target_id, max_y_axis, is_doller_format = false) => {
		initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter(target_id, "#"), "");
		const chart_config = _default_config.charts[_default_config.resource];
		const dd = $(".monthly-summery").height() + ($("header").length ? (30 + $("header").height()) : 0) + ($(".mainnav").length ? $(".mainnav").height() : 0);
		Object.assign(chart_config, {
			"max_y_axis": max_y_axis,
			"id": "#" + target_id,
			"width": _default_config.width.chart1,
			"data": data,
			"is_doller_format": is_doller_format,
			"tooltip": {
				"top": dd - 10,
				"left": (is_doller_format ? 0 : 1) * 15,
				"diff_class": "graph",
				"diff": true
			}
		});
		const tick_values = [0], tick_origin_value = max_y_axis / 5;
		if (!is_doller_format) {
			for (let i = 0; i < 4; ++i) tick_values.push(Math.floor((max_y_axis < 6) ? i : (tick_values[tick_values.length - 1] + tick_origin_value)));
			tick_values.push(Math.floor(max_y_axis));
			chart_config.tick_values = initScript.uniqueData(tick_values);
		}
		else if(chart_config.hasOwnProperty("tick_values")) delete chart_config.tick_values;
		for (let i = 0; i < _default_config.total_sources; ++i)
			chart_config.color.bars["field" + (i + 1)] = _default_config.color_codes[i];
		charts.bar.init(chart_config);
	};

    /**
     * updateLegends : updating legends
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function updateLegends(localSources) {
		let html_legends = "";
		if(!localSources) localSources = _default_config.sources
        for (let i = 0; i < localSources.length; ++i) {
            let html = initScript.bindAttrsOnHTMLTag("span", "", {
                "style": { "background": _default_config.color_codes[i] }
            }) + initScript.bindAttrsOnHTMLTag("label", localSources[i]);
            html_legends += initScript.bindAttrsOnHTMLTag("li", html );
		}

        initScript.innerHTMLToATarget("#countOfPaymentsPieChartegends", html_legends);
        initScript.innerHTMLToATarget("#debtRepaidPieChartLegends", html_legends);
	}

	/**
     * refreshHTML : showing consolidated html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function refreshHTML() {
		_default_config.data = _default_config.maped_data[_default_config.last_selected_account_number_option];
		if(!_default_config.data) _default_config.data = []; 
		templateUtil.appendTabelRows(_default_config);
	}

    /**
     * getDebtAnalysisSelectedValue : returning selected value
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     */

	function getDebtAnalysisSelectedValue(event) {
		let selected_val = event.target.value.trim(), classes = event.target.classList.length ? event.target.classList : event.target.parentElement.classList, type = classes[classes.length - 1], is_month_filter = (type.search("month") !== -1) ? true : false;
		if (is_month_filter && selected_val === _default_config._default_option) {
			clearElements();
			updateBarChart();
			_default_config.last_selected_month_option = selected_val;
			return;
		}
		if (is_month_filter && _default_config.last_selected_month_option === selected_val) return;
		if (_default_config.last_selected_account_number_option !== selected_val) {
			clearElements();
			if ((is_month_filter || _default_config.last_selected_month_option !== _default_config._default_option) && selected_val !== _default_config._default_option) {
				if (is_month_filter) _default_config.last_selected_month_option = selected_val;
				else _default_config.last_selected_account_number_option = selected_val;
				// _default_config.last_selected_month_option = selected_val;
				updatePieChart();
			}
			else {
				_default_config.last_selected_account_number_option = selected_val;
				if(_default_config.last_selected_month_option !== _default_config._default_option)
				updatePieChart();
				else
				updateBarChart();
			}
			refreshHTML();
		}
		if (is_month_filter) _default_config.last_selected_month_option = selected_val;
		else _default_config.last_selected_account_number_option = selected_val;
	}

    /**
     * clearElements : clearing html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function clearElements() {
		const element1 = initScript.getHTMLElementByDelimiter("countOfPaymentsPieChart", "#"), element2 = initScript.getHTMLElementByDelimiter("debtRepaidPieChart", "#");
		initScript.innerHTMLToATarget(element1, "");
		initScript.innerHTMLToATarget(element2, "");
		element1.removeClass("empty-data-section");
		element2.removeClass("empty-data-section");
	}

	function setDataByDebtCategory(event) {
		_default_config.active_data_category = event.target.value.trim();
		_default_config.maped_data[_default_config._default_option] = updateData(_default_config["category_wise_data"][_default_config.active_data_category]);

		for (let i = 0; i < _default_config.account_level.length; ++i){
			if(_default_config.account_level[i]["report"] && _default_config.account_level[i]["report"].length > 0){
				let accountLevelDebtWiseData = _default_config.account_level[i]["report"].find(e => e.category === _default_config.active_data_category)
				_default_config.maped_data[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = (accountLevelDebtWiseData && accountLevelDebtWiseData["data"])?updateData(accountLevelDebtWiseData["data"]):[];
			}
		}		
		clearElements()
		if(_default_config.last_selected_month_option !== _default_config._default_option)
			updatePieChart();
		else
			updateBarChart();
		refreshHTML();
	}

	return {
		init,
		getDebtAnalysisSelectedValue,
		setDataByDebtCategory
	};
})();
